import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import AreaValidations from 'scaleflow/validators/area';

export interface QuickAddsAreaSignature {
  // The arguments accepted by the component
  Args: {
    isOpen?: boolean;
    handleFormDismiss?: () => void;
    onItemSaved?: (area: any) => void;
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: null;
}

export default class QuickAddsAreaComponent extends Component<QuickAddsAreaSignature> {
  @service declare store: any;
  @service declare router: any;

  area = {
    name: '',
  };
  areaValidations = AreaValidations;

  @action
  async onSubmit(changeset: any, e: Event) {
    e.preventDefault();
    try {
      await changeset.validate();
      if (changeset.isInvalid) {
        console.debug(changeset.errors);
        return;
      }
      const area = this.store.createRecord('area', {
        name: changeset.name,
      });
      await area.save();
      this.args?.onItemSaved?.(area);
      this.handleModalDismiss();
    } catch (err) {
      console.log(err);
    }
  }

  @action
  handleModalDismiss() {
    this.args?.handleFormDismiss?.();
  }
}
